import { fg } from '@atlaskit/platform-feature-flags/fg';
import type { AgentSessionsScope } from '@atlassian/agent-sessions/types';

/** Navigation and All Chats must share query variables to reuse the same Relay connection. */
export const createChatAgentSessionsOptions = (
	scope: AgentSessionsScope,
): AgentSessionsScope & { includeLocalAgentSessions: boolean } => ({
	...scope,
	includeLocalAgentSessions: fg('rovo_chat_all_chats_local_agent_sessions'),
});
